module.exports = __webpack_public_path__ + "static/media/sport.d899c13e.jpg";